import(/* webpackMode: "eager" */ "/home/ubuntu/download/6983576c921dc90014825455/vehicletracker/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6983576c921dc90014825455/vehicletracker/src/app/dashboard/components/NotificationOptIn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6983576c921dc90014825455/vehicletracker/src/app/dashboard/components/VehicleTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6983576c921dc90014825455/vehicletracker/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6983576c921dc90014825455/vehicletracker/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6983576c921dc90014825455/vehicletracker/src/components/ui/AppImage.tsx");
